import { ArrowLeft, ArrowRight } from 'lucide-react';
import './ServiceDetail.css';
import ScrollToTop from '../../Components/Scrolltop/Scrolltop';

const Merl = () => {
   <ScrollToTop />
  return (
    <>
      <section className="service-hero">
        <div className="container">
          <a href="/services" className="back-link">
            <ArrowLeft size={24} /> Back to All Services
          </a>
          <h1>Monitoring, Evaluation, Research & Learning (MERL) Systems</h1>
          <p className="lead">
            We design and operationalise robust MERL systems that support accountability, performance management, and evidence-informed decision-making across the project cycle.
          </p>
        </div>
      </section>

      <section className="section service-detail">
        <div className="container">
          <h2>Our Key Services</h2>
          <ul className="service-list">
            <li>
              <strong>Theory of Change and Results Framework design</strong>
              <p>Clear logic models that connect activities to outcomes and long-term impact with measurable, realistic indicators.</p>
            </li>
            <li>
              <strong>Indicator development and data quality assurance systems</strong>
              <p>SMART indicators paired with robust verification, validation, and data audit processes to ensure reliability.</p>
            </li>
            <li>
              <strong>Outcome harvesting and contribution analysis</strong>
              <p>Capturing emergent outcomes and rigorously assessing how and to what extent the programme contributed to change.</p>
            </li>
            <li>
              <strong>Digital data collection systems (Kobo, SurveyCTO, ODK)</strong>
              <p>Mobile-first, offline-capable tools for efficient, high-quality field data collection and real-time syncing.</p>
            </li>
            <li>
              <strong>Learning and reflection platforms for adaptive programming</strong>
              <p>Structured workshops, pause-and-reflect sessions, and feedback loops to turn data into timely programme adjustments.</p>
            </li>
          </ul>

          <div className="cta-section">
            <h3>Ready to Build a World-Class MERL System?</h3>
            <div className="btn-group">
              <a href="/contact" className="btn btn-primary">
                Start Building Your MERL Framework <ArrowRight size={24} />
              </a>
              <a href="/services" className="btn btn-secondary">
                Explore All Services <ArrowRight size={24} />
              </a>
            </div>
          </div>
        </div>
      </section>

      <footer className="footer">
        <div className="footer-grid">
          <div>
            <div className="footer-logo">DevLearn Impact Research Ltd</div>
            <p>Plot No. 3788/A, Avondale Road, Lusaka</p>
            <p>+260 973 902 981 / +260 978 341 825</p>
            <p>info@devlearnimpact.com</p>
          </div>
          <div>
            <h4>Services</h4>
            <ul>
              <li><a href="/services">Applied Research</a></li>
              <li><a href="/services">MERL Frameworks</a></li>
              <li><a href="/services">Capacity Building</a></li>
            </ul>
          </div>
          <div>
            <h4>Thematic Areas</h4>
            <ul>
              <li><a href="/sectors">Education & Health</a></li>
              <li><a href="/sectors">Governance & Climate</a></li>
              <li><a href="/sectors">Economic Inclusion</a></li>
            </ul>
          </div>
          <div>
            <h4>Company</h4>
            <ul>
              <li><a href="/about">About</a></li>
              <li><a href="/team">Team</a></li>
              <li><a href="/case-studies">Projects</a></li>
            </ul>
          </div>
          <div>
            <h4>Connect</h4>
            <ul>
              <li><a href="https://www.linkedin.com/company/devlearn-impact-research/">LinkedIn</a></li>
              <li><a href="https://www.facebook.com/share/1AS3Ahfsy7/">Facebook</a></li>
            </ul>
          </div>
        </div>
        <div className="copyright">
          © 2025 DevLearn Impact Research Ltd. All rights reserved. Registered in Zambia, June 28, 2025.
        </div>
      </footer>
    </>
  );
};

export default Merl;